import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

// Connects to data-controller="menu"
export default class extends Controller {
  static targets = ["menu"];
  static classes = ["show"];

  connect() {
    useClickOutside(this);
  }

  open(e) {
    e.target.blur();
    e.preventDefault();

    this.menuTargets.forEach((target) => {
      target.classList.toggle(this.showClass);
    });
  }

  clickOutside(_e) {
    this.menuTargets.forEach((target) => {
      target.classList.remove(this.showClass);
    });
  }
}
